import script from "./DeliveryCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./DeliveryCardComponent.vue?vue&type=style&index=0&id=3bbccb84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bbccb84"]])

export default __exports__